export type Platform = "windows" | "macos" | "linux";

/**
 * Mapea el UA a la plataforma que espera el installer/updates API. Hoy solo se
 * publican releases de Windows, pero el dispatch queda listo para macOS/Linux.
 */
export const detectPlatform = (): Platform => {
  if (typeof navigator === "undefined") return "windows";

  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes("mac")) return "macos";
  if (ua.includes("linux")) return "linux";

  return "windows";
};

/**
 * `true` si `latest` es estrictamente mayor que `current` (semver por partes).
 * Devuelve `false` ante datos faltantes o "Unknown" para no ofrecer updates
 * fantasma.
 */
export const isNewerVersion = (
  current: string | null | undefined,
  latest: string | null | undefined,
): boolean => {
  if (!latest || !current || current === "Unknown") return false;

  // parseInt del primer entero de cada segmento ("3-beta" -> 3), alineado con
  // sortReleasesBySemverDesc del backend. Number(...) daba NaN con sufijos.
  const currentParts = current.split(".").map((s) => parseInt(s, 10) || 0);
  const latestParts = latest.split(".").map((s) => parseInt(s, 10) || 0);

  for (let i = 0; i < Math.max(currentParts.length, latestParts.length); i++) {
    const currentPart = currentParts[i] || 0;
    const latestPart = latestParts[i] || 0;

    if (latestPart > currentPart) return true;
    if (latestPart < currentPart) return false;
  }

  return false;
};
